module.exports = __webpack_public_path__ + "img/portalcegonheiro.79da3c85.webp";